// extracted by mini-css-extract-plugin
module.exports = {"container":"e_ag","hasBadge":"e_bg","bottomLine":"e_cg","imageContainer":"e_dg","image":"e_eg","header":"e_fg","title":"e_gg","score":"e_hg"};